import { useQuery } from '@tanstack/vue-query';

import { inject, provide } from 'vue';
import type { Ref } from 'vue';
import { useRoute } from 'vue-router';

import type { DeviceStatus } from '@eaphone/types/resources';

import { getStatus } from './xhr.ts';

type Share = Ref<DeviceStatus | undefined>;

export function useLogic() {
  const route = useRoute();

  const { data } = useQuery({
    queryKey: ['status', route.query.serial],
    queryFn: () => getStatus({ serial: route.query.serial as string }),
    refetchInterval: 5000,
  });

  provide<Share>('data', data);

  return { data };
}

export function useDeviceStatus() {
  return inject<Share>('data');
}
